import { render, staticRenderFns } from "./BmModalFull.vue?vue&type=template&id=bd6a4ba2&scoped=true&"
import script from "./BmModalFull.vue?vue&type=script&lang=js&"
export * from "./BmModalFull.vue?vue&type=script&lang=js&"
import style0 from "./BmModalFull.vue?vue&type=style&index=0&id=bd6a4ba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6a4ba2",
  null
  
)

export default component.exports